import React, { Component } from 'react';

import locations from '../../locations';

export class Settings extends Component {
  render() {
    return (
      <div className="col-md-9 content">
        <h3>Locations</h3>
        <p>Manage the locations available when booking your sessions.</p>
        <locations.components.LocationListContainer isEditable={true} />
      </div>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/modules/settings/components/Settings.js